import axios from 'axios';
import React, { Fragment, useContext, useEffect, useState } from 'react'
import {Link, useNavigate, useParams } from 'react-router-dom'
import Swal from 'sweetalert2';
import "./specificOrder.css"
import { UserContext } from '../../../Context/UserContext.js';


export default function SpecificOrder() {

   const{id} = useParams () ;
   const navigate = useNavigate() ;
   const {userToken } = useContext(UserContext) ;
   const[orderDetails , setOrderDetails] = useState({}) ;
   const[items , setItems] = useState([]) ;


   const header = {
      token:`${process.env.REACT_APP_BEARER_TOKEN} ${userToken || localStorage.getItem("token")}`
   }


   async function getOrderDetails(){
      let response =   await axios.get(`${process.env.REACT_APP_BASE_URL}/api/v1/order/${id}`  ,  {headers:header} )
      .catch((error)=>{
         Swal.fire({
            title:error.response.data.message  ,
            text: "Please Try Again" ,   
            icon: "error"
            });
      })
      if(response?.data.message === "success"){
         setOrderDetails(response.data?.order);
         setItems(response.data?.order.orderItems)
      }
   }



   async function cancelOrder(id){
      const message = window.prompt()
         Swal.fire({
            title: "Are you sure?",
            text: "You won't be Cancel this Order!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, Cancel it!"
         }).then(async(result) => {
            if (result.isConfirmed) {
               let response =   await axios.put(`${process.env.REACT_APP_BASE_URL}/api/v1/order/${id}`  , {message} ,  {headers:header} )
               .catch((error)=>{
                  Swal.fire({
                     title:error.response?.data.message  ,
                     text: "Please Try Again" ,   
                     icon: "error"
                     });
               })
               if(response?.data.message === "success"){
                  Swal.fire({
                     position: "top-center",
                     icon: "success",
                     title: response?.data.message ,
                     showConfirmButton: false,
                     timer: 1000
                  });
                  window.location.reload();
               }
            }
         });
   }


   async function deletedOrder(id){
         Swal.fire({
            title: "Are you sure?",
            text: "You won't be Delete this Order!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, Delete it!"
         }).then(async(result) => {
            if (result.isConfirmed) {
               let response =   await axios.delete(`${process.env.REACT_APP_BASE_URL}/api/v1/order/${id}` ,  {headers:header} )
               .catch((error)=>{
                  Swal.fire({
                     title:error.response?.data.message  ,
                     text: "Please Try Again" ,   
                     icon: "error"
                     });
               })
               if(response?.data.message === "success"){
                  Swal.fire({
                     position: "center-center",
                     icon: "success",
                     title: "Deleted Successfully" ,
                     showConfirmButton: false,
                     timer: 1000
                  });
                  navigate("/dashBoard")
               }
            }
         });
   }



   async function deletedOrderMedia(id){
         Swal.fire({
            title: "Are you sure?",
            text: "You won't be Delete this Order Media !",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, Delete it!"
         }).then(async(result) => {
            if (result.isConfirmed) {
               let response =   await axios.delete(`${process.env.REACT_APP_BASE_URL}/api/v1/order/media/${id}` ,  {headers:header} )
               .catch((error)=>{
                  Swal.fire({
                     title:error.response?.data.message  ,
                     text: "Please Try Again" ,   
                     icon: "error"
                     });
               })
               if(response?.data.message === "success"){
                  Swal.fire({
                     position: "center-center",
                     icon: "success",
                     title: "Media Deleted Successfully" ,
                     showConfirmButton: false,
                     timer: 1000
                  });
                  navigate("/dashBoard")
               }
            }
         });
   }











   function handleShare(fileUrl) {
      if (navigator.share) {
         navigator.share({
            title: 'فاتورة جديدة',
            text: 'شوف الفاتورة دي من فضلك',
            url: fileUrl,
         })
         .then(() => console.log('تمت المشاركة بنجاح'))
         .catch((err) => console.error('خطأ أثناء المشاركة:', err));
      } else {
         alert("المشاركة غير مدعومة على هذا الجهاز");
      }
   }







   useEffect(() => {
      getOrderDetails()
   }, [])
   
   return (
      <Fragment>
         <div className="container">
            
            <h1 className='main-header'>Specific Order</h1>
            <div className='under-header'></div>


            <div className="row g-1">
            {
               orderDetails.is_Cancel?
                  <span className='alert alert-danger  fw-bold text-center p-1'>تم ألغاء الطلب <i className="fa-solid fa-ban ms-4"></i></span>
               :orderDetails.is_Paid && orderDetails.is_Approved ? 
                  <span className='alert alert-secondary fw-bold text-center p-1 text-success'>تم سحب العينات <i className="fa-solid fa-thumbs-up ms-4"></i></span>
               : !orderDetails.is_Paid ?
                  <span className='alert alert-primary fw-bold text-center p-1' >تم تسجيل الطلب بنجاح وفى انتظار اعطاء الموافقة من مقدم الخدمة<i className="fa-solid fa-ban ms-4"></i></span>
               :<span className='alert alert-primary fw-bold text-center p-1'>حدث خطأ اثناء التسجيل<i className="fa-solid fa-exclamation ms-4"></i></span>
            }

               <div className="col-md-12 mb-4">
                  <h3 className='text-center'>Patient Information</h3>
                  <div className='border border-1 p-2 rounded-2'>
                     <table className="table table-sm table-striped">

                        <tbody>
                           <tr>
                              <th scope="row">Name :</th>
                              <td>{orderDetails.patient_Name}</td>
                           </tr>
                           <tr>
                              <th scope="row">Age :</th>
                              <td>{orderDetails.patient_Age}</td>
                           </tr>
                           <tr>
                              <th scope="row">Phone Number :</th>
                              <td>{orderDetails.patient_Phone}</td>
                           </tr>
                           <tr>
                              <th scope="row">Birthday :</th>
                              <td>{orderDetails?.birthDay?.split("T")[0]}</td>
                           </tr>
                           <tr>
                              <th scope="row">Branch :</th>
                              <td>{orderDetails?.branch?.name || orderDetails?.user?.role === "admin" ?`Approved By Admin ${orderDetails?.user?.name.toUpperCase()}`:"Approved By Admin!" }</td>
                           </tr>
                        </tbody>

                     </table>
                  </div>
               </div>

               <div className="col-md-12 mb-4">
                  <h3 className='text-center'>Order Information</h3>
                  <div className='border border-1 p-2 rounded-2'>
                     <table className="table table-sm table-striped">

                        <tbody>
                           <tr>
                              <th scope="row">total_Price :</th>
                              <td>{Math.round(orderDetails.total_Price)}  EGP</td>
                           </tr>
                           <tr>
                              <th scope="row">total_Price_After_Discount :</th>
                              <td>{Math.round(orderDetails.total_Price_After_Discount)}  EGP</td>
                              
                           </tr>
                           <tr>
                              <th scope="row">Contract_Price :</th>
                              <td>{Math.round(orderDetails.Contract_Price)}  EGP</td>
                           </tr>
                           <tr>
                              <th scope="row">Net_Amount :</th>
                              <td>{Math.round(orderDetails.Net_Amount)}  EGP</td>
                           </tr>
                           <tr>
                              <th scope="row">invoice Number :</th>
                              <td>{orderDetails.invoice_number}</td>
                           </tr>
                           <tr>
                              <th scope="row">Order Number :</th>
                              <td>{orderDetails.order_Number}</td>
                           </tr>
                           <tr>
                              <th scope="row">is Paid :</th>
                              <td>{orderDetails.is_Paid ? <span className='text-success'>Yes <i className="fa-solid fa-check m-2"></i></span>: <span className='text-danger m-0 p-0'>No <i className="fa-solid fa-xmark m-2"></i></span>}</td>
                           </tr>
                           <tr>
                              <th scope="row">is Cancel  :</th>
                              <td>{orderDetails.is_Cancel ? <span className='text-success'>Yes  {orderDetails.cancel_At?.slice(0 , 10)}<i className="fa-solid fa-check m-2"></i></span>: <span className='text-danger m-0 p-0'>No <i className="fa-solid fa-xmark m-2"></i></span>}</td>
                           </tr>


                           <tr>
                              <th scope="row">Service provider Approved :</th>
                              <td>{orderDetails.is_Approved ? <span className='text-success'>Yes  {orderDetails.approved_At?.slice(0 , 10)}<i className="fa-solid fa-check m-2"></i></span>: <span className='text-danger m-0 p-0'>No <i className="fa-solid fa-xmark m-2"></i></span>}</td>
                           </tr>
                           <tr>
                              <th scope="row">Message :</th>
                              <td>{orderDetails.message ? <p className='text-center w-100'>{orderDetails.message}</p> : <p className='text-center ss'>Not Found The Message Until Now !</p>}</td>
                           </tr>
                        </tbody>

                     </table>
                  </div>
               </div>

               <div className="col-md-6 mb-4">
                  <h3 className='text-center'>User Information</h3>
                  <div className='border border-1 p-2  rounded-2'>
                     <table className="table table-sm table-striped">

                        <tbody>
                           <tr>
                              <th scope="row">Name :</th>
                              <td>{orderDetails?.user?.name}</td>
                           </tr>
                           <tr>
                              <th scope="row">Age :</th>
                              <td>{orderDetails?.user?.age}</td>
                           </tr>
                           <tr>
                              <th scope="row">Phone Number :</th>
                              <td>{orderDetails?.user?.phone}</td>
                           </tr>

                           <tr>
                              <th scope="row">Email :</th>
                              <td>{orderDetails?.user?.email}</td>
                           </tr>
                        </tbody>

                     </table>
                  </div>
               </div>

               <div className="col-md-6 mb-4">
                  <h3 className='text-center'>Company Information</h3>
                  <div className='border border-1 p-2  rounded-2'>
                     <table className="table table-sm table-striped">

                        <tbody>
                           <tr>
                              <th scope="row">Name :</th>
                              <td>{orderDetails.company?.name}</td>
                           </tr>
                           <tr>
                              <th scope="row">Address :</th>
                              <td>{orderDetails.company?.address}</td>
                           </tr>
                           <tr>
                              <th scope="row">Phone Number :</th>
                              <td>{orderDetails.company?.phone}</td>
                           </tr>

                           <tr>
                              <th scope="row">Email :</th>
                              <td>{orderDetails.company?.email}</td>
                           </tr>

                           <tr>
                              <th scope="row">Logo :</th>
                              <td><img src={orderDetails.company?.logo} className='w-50' alt="" /></td>
                           </tr>
                        </tbody>

                     </table>
                  </div>
               </div>

               <div  className="col-md-12 mb-4   pt-4">
                  <h3 className='text-center  border-3 border-bottom py-5'>Order Information</h3>
                  <table className="table text-center  table-sm ">

                     <thead>
                        <tr>
                           <th>number</th>
                           <th>Test</th>
                           <th>Price</th>
                           <th>Price After Discount</th>
                           <th>Contract Price</th>
                           <th>Net Amount</th>
                        </tr>
                     </thead>
                     <tbody>
                        {
                           items.map((ele , index)=>{
                              return (
                                       <tr key={index}>
                                          <td>{index + 1}</td>
                                          <td>{ele.test?.name}</td>
                                          <td>{Math.round(Number(ele.price) || 0)}</td>
                                          <td>{Math.round(Number(ele.priceAfterDiscount) || 0)}</td>
                                          <td>{Math.round(Number(ele.contract_Price) || 0)}</td>
                                          <td>{Math.round(Number(ele.final_amount) || 0)}</td>
                                       </tr>
                              )
                           })
                        }
                     </tbody>

                     <tfoot className='bg-light'>
                        <tr>
                           <td colSpan="2" className='py-1 fw-bold' >Total :</td>
                           <td className='py-1 fw-bold'>{Math.round(Number(orderDetails.total_Price) || 0)}</td>
                           <td className='py-1 fw-bold'>{Math.round(Number(orderDetails.total_Price_After_Discount) || 0)}</td>
                           <td className='py-1 fw-bold'>{Math.round(Number(orderDetails.Contract_Price) || 0)}</td>
                           <td className='py-1 fw-bold'>{Math.round(Number(orderDetails.Net_Amount) || 0)}</td>
                        </tr>
                     </tfoot>

                  </table>
               </div>

               <div className='text-center'>
                  <Link to={orderDetails.invoice_pdf}  className='btn btn-dark btn-sm ' target='_blank' >Download Invoice <i className="fa-solid fa-print ms-4"></i></Link>
                  <Link to={orderDetails.transform_pdf} className='btn btn-dark btn-sm d-inline-block m-2' target='_blank'  >Download Translate <i className="fa-solid fa-print ms-4"></i></Link>
               </div>

               <div className='text-center mt-2'>
                  <button onClick={()=>{cancelOrder(orderDetails._id)}}  disabled={orderDetails.is_Cancel || orderDetails.is_Approved} className="btn btn-danger btn-sm my-2 ms-2 w-50" >Cancel Order<i className="fa-solid fa-xmark ms-4"></i></button>
                  <button onClick={()=>{deletedOrder(orderDetails._id)}}  className="btn btn-danger btn-sm my-2 ms-2 w-50">Delete Order<i className="fa-regular fa-trash-can ms-4"></i></button>
               </div>
            </div>

            <div className="d-flex gap-2 justify-content-center">
               <button onClick={()=>{handleShare(orderDetails.transform_pdf)}} className="btn btn-primary">مشاركة (Share)</button>
               <button onClick={()=>{deletedOrderMedia(orderDetails._id)}} className="btn btn-primary">Delete Media</button>
            </div>

         </div>
      </Fragment>
   )
}
